import React from "react";

const root = window.post_template?.checkout_v4_topbar;
const topbarText = root.tr_checkout_v4_topbar_discount;
const backgroundColor = root.checkout_v4_topbar_background;
const textColor = root.checkout_v4_topbar_textColor;

const TopbarOffer = () => {
  return (
    <div className="topbarOffer" style={{ background: backgroundColor, color: textColor }}>
      {topbarText}
    </div>
  );
};

export default TopbarOffer;
